import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {ItemState} from "./ItemState";
import {ItemKindModel} from "@/modules/redactor/models/item/core/ItemKindModel";

export class ItemKey extends Cloneable {

  static schema() {
    return custom(
      (v) => {
        let result = SKIP;

        if (v && v.valid()) {
          result = serialize(ItemKey, v);

          if (result["state"] === 0) {
            delete result["state"];
          }
        }

        return result;
      },
      (v) => {
        let key = deserialize(ItemKey, v);

        if (!key || !key.valid()) {
          console.warn("invalid key level" + JSON.stringify(key));
        }

        return key;
      }
    );
  }

  constructor(kind = null, level = 0) {
    super();
    this._kind = kind;
    this._level = level;
    this._state = ItemState.NONE;
    this._amount = 0;
  }

  get kind() {
    return this._kind;
  }

  set kind(value) {
    this._kind = value;
  }

  get level() {
    return this._level;
  }

  set level(value) {
    this._level = value;
  }

  get state() {
    return this._state;
  }

  set state(value) {
    this._state = value;
  }

  get amount() {
    return this._amount;
  }

  set amount(value) {
    this._amount = value;
  }

  get value() {
    return (this.kind ? this.kind.key : "unknown") + "_" + this.level;
  }

  get string() {
    if (this.kind) {
      return `${this.kind.key} (${this.level})`;
    } else {
      return "None";
    }
  }

  equal(value) {
    if (value instanceof ItemKey) {

      if (!this.kind || !this.kind.equal(value.kind)) {
        return false;
      } else if (this.level !== value.level) {
        return false;
      }

      return true;
    }

    return false;
  }

  valid() {
    if (!ItemKindModel.is(this.kind)) {
      return false;
    }

    if (!Number.isInteger(this.level) || this.level < 0) {
      return false;
    }

    if (this.level !== 100 && !this.kind.valid(this.level)) {
      return false;
    }

    if (this.state && !ItemState.is(this.state)) {
      return false;
    }

    if (!Number.isInteger(this.amount) || this.amount < 0) {
      return false;
    }

    return true;
  }

  any() {
    return this.level === 100 || ItemKindModel.isAny(this.kind);
  }

  complex() {

    if (this.amount > 0) {
      return true;
    }

    if (this.state && !ItemState.isNone(this.state)) {
      return true;
    }

    return false;
  }

  empty() {
    return !ItemKindModel.is(this.kind);
  }

  copy() {
    return this.clone();
  }

  clone(target = undefined) {
    if (!target) {
      return super.clone(new ItemKey());
    } else if (target instanceof ItemKey) {
      return super.clone(target);
    } else {
      console.assert(false);
      return undefined;
    }
  }
}

createModelSchema(ItemKey, {
  _kind: alias("kind", ItemKindModel.schema()),
  _level: alias("level", Schema.primitive()),
  _state: alias("state", ItemState.schema()),
  _amount: alias("amount", Schema.primitive())
});